/* whatsapp-flotante.js — MÓDULO «WhatsApp flotante» · Tecnocom 2026-10-02
   Ver snippets/whatsapp-flotante.liquid.

   1. ARRASTRAR: con el dedo o el ratón. Un movimiento de menos de 6 px es un
      toque y abre WhatsApp; más es arrastre y NO abre nada. Al soltar se pega al
      borde más cercano (izquierda o derecha) y guarda lado + altura en el
      navegador del cliente (localStorage, que puede no existir: try/catch).
   2. NO CHOCAR: se sube lo justo para no tapar lo que el tema fija abajo y que
      esté en su mismo lado: la barra de compra de la ficha, el «volver arriba»,
      la barra inferior del celular (Vision 18), el aviso de cookies y la barra
      de vista previa de Shopify. Nunca queda bajo la cabecera ni fuera de pantalla.
   3. MEDIR: cada clic cuenta como contacto en GA4/Ads (gtag), Meta (fbq) y los
      eventos de Shopify, si están cargados. */
(function () {
  if (customElements.get('tc-whatsapp')) return;

  var CLAVE = 'tc-wa-pos';
  var UMBRAL = 6;          // px: menos es un toque
  var SEPARACION = 10;     // px libres entre el botón y lo que esquiva
  var OBSTACULOS = [
    'product-add-to-cart-sticky.sticky--visible',
    'back-to-top.back-to-top--active',
    '.mobile-dock',
    '#shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '#preview-bar-iframe',
    '#PBarNextFrameWrapper'   // barra de vista previa de Shopify (solo al previsualizar un tema)
  ];

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || 'null'); } catch (e) { return null; }
  }
  function guardar(v) {
    try { localStorage.setItem(CLAVE, JSON.stringify(v)); } catch (e) { /* modo privado: no pasa nada */ }
  }
  function abajoInicial() { return window.innerWidth >= 1068 ? 30 : 20; }

  class TcWhatsapp extends HTMLElement {
    connectedCallback() {
      this.boton = this.querySelector('.tc-wa__boton');
      if (!this.boton) return;
      var g = leer();
      this.lado = (g && (g.lado === 'left' || g.lado === 'right')) ? g.lado : (this.dataset.lado || 'right');
      // La altura se guarda como fracción de la ventana: sobrevive a girar el teléfono.
      this.fraccion = (g && typeof g.fraccion === 'number') ? g.fraccion : null;
      this.ponerLado(this.lado);
      this.aplicarAbajo();

      this.arrastre = null;
      this.acabaDeArrastrar = false;
      this.boton.addEventListener('pointerdown', this.alPresionar.bind(this));
      this.boton.addEventListener('pointermove', this.alMover.bind(this));
      this.boton.addEventListener('pointerup', this.alSoltar.bind(this));
      this.boton.addEventListener('pointercancel', this.alSoltar.bind(this));
      this.boton.addEventListener('dragstart', function (e) { e.preventDefault(); });
      this.boton.addEventListener('click', this.alClic.bind(this));

      var programado = false, self = this;
      this.programar = function () {
        if (programado) return;
        programado = true;
        requestAnimationFrame(function () { programado = false; self.esquivar(); });
      };
      window.addEventListener('scroll', this.programar, { passive: true });
      window.addEventListener('resize', function () { self.aplicarAbajo(); self.programar(); });
      // El «volver arriba» y la barra de compra cambian de clase al desplazarse y
      // luego se animan ~0.3 s: se vuelve a medir cuando terminan.
      // El recálculo diferido va DIRECTO, sin requestAnimationFrame: el navegador
      // lo congela con ahorro de batería o la pestaña al fondo, y medido el 2-oct
      // así se quedaba el botón encima de la barra de compra.
      var tardio = function () { self.esquivar(); };
      this.observador = new MutationObserver(function () {
        self.programar();
        clearTimeout(self.tardio);
        self.tardio = setTimeout(tardio, 400);
      });
      this.observador.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      // Las hojas de estilo de lo que hay que esquivar (barra inferior, barra de
      // compra) cargan DIFERIDAS: medido el 2-oct, a los 600 ms la barra inferior
      // aún no era fija y el botón quedó encima. Se vuelve a medir al terminar de
      // cargar y un par de veces más; nada de eso cambia clases, así que el
      // observador no se entera solo.
      setTimeout(tardio, 600);
      window.addEventListener('load', tardio);
      setTimeout(tardio, 1500);
      setTimeout(tardio, 4000);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.programar);
      if (this.observador) this.observador.disconnect();
    }

    ponerLado(lado) {
      this.lado = lado;
      this.classList.toggle('tc-wa--left', lado === 'left');
      this.classList.toggle('tc-wa--right', lado === 'right');
    }

    limites() {
      var alto = this.boton.offsetHeight || 52;
      var cabecera = document.querySelector('.header-section, theme-header, header');
      var techo = cabecera ? Math.max(0, cabecera.getBoundingClientRect().bottom) : 0;
      return { min: 12, max: Math.max(12, window.innerHeight - techo - alto - 12) };
    }

    aplicarAbajo() {
      var l = this.limites();
      var abajo = this.fraccion === null ? abajoInicial() : this.fraccion * window.innerHeight;
      this.abajo = Math.min(Math.max(abajo, l.min), l.max);
      this.style.setProperty('--tc-wa-abajo', this.abajo + 'px');
    }

    /* Cuánto subir para no tapar nada de su lado. Se calcula con la posición
       ELEGIDA (sin la subida anterior) y en varias pasadas, por si al subir
       queda encima de otro obstáculo apilado. */
    esquivar() {
      if (this.arrastre) return;
      var alto = this.boton.offsetHeight || 52;
      var ancho = this.boton.offsetWidth || 52;
      var margen = parseFloat(getComputedStyle(this).getPropertyValue('--tc-wa-margen')) || 16;
      var x0 = this.lado === 'left' ? margen : window.innerWidth - margen - ancho;
      var x1 = x0 + ancho;
      var rects = [];
      OBSTACULOS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
          var r = el.getBoundingClientRect();
          if (r.width === 0 || r.height === 0 || r.top >= window.innerHeight || r.bottom <= 0) return;
          if (r.right <= x0 || r.left >= x1) return;          // no está en su lado
          rects.push(r);
        });
      });
      var sube = 0;
      for (var pasada = 0; pasada < 4; pasada++) {
        var fondo = window.innerHeight - this.abajo - sube;   // borde inferior del botón
        var tope = fondo - alto;
        var mas = 0;
        rects.forEach(function (r) {
          if (r.top < fondo + SEPARACION && r.bottom > tope - SEPARACION) {
            mas = Math.max(mas, fondo - r.top + SEPARACION);
          }
        });
        if (mas <= 0) break;
        sube += mas;
      }
      var l = this.limites();
      sube = Math.max(0, Math.min(sube, l.max - this.abajo));
      this.style.setProperty('--tc-wa-sube', sube + 'px');
    }

    alPresionar(e) {
      if (e.button !== undefined && e.button !== 0) return;
      var r = this.getBoundingClientRect();
      this.arrastre = { x: e.clientX, y: e.clientY, dx: e.clientX - r.left, dy: e.clientY - r.top, movido: false };
      try { this.boton.setPointerCapture(e.pointerId); } catch (err) { /* sin captura también funciona */ }
    }

    alMover(e) {
      var a = this.arrastre;
      if (!a) return;
      if (!a.movido && Math.hypot(e.clientX - a.x, e.clientY - a.y) < UMBRAL) return;
      if (!a.movido) {
        a.movido = true;
        this.classList.add('tc-wa--arrastrando');
        this.style.setProperty('--tc-wa-sube', '0px');
      }
      e.preventDefault();
      var ancho = this.offsetWidth, alto = this.offsetHeight;
      var izq = Math.min(Math.max(e.clientX - a.dx, 0), window.innerWidth - ancho);
      var arriba = Math.min(Math.max(e.clientY - a.dy, 0), window.innerHeight - alto);
      this.style.left = izq + 'px';
      this.style.right = 'auto';
      this.style.setProperty('--tc-wa-abajo', (window.innerHeight - arriba - alto) + 'px');
    }

    alSoltar(e) {
      var a = this.arrastre;
      this.arrastre = null;
      if (!a || !a.movido) return;
      this.acabaDeArrastrar = true;                  // el click que sigue NO abre WhatsApp
      // …pero si el navegador no manda ese click (se soltó fuera), la marca no
      // puede quedarse: el SIGUIENTE toque real no abriría nada.
      var self = this;
      setTimeout(function () { self.acabaDeArrastrar = false; }, 350);
      var r = this.getBoundingClientRect();
      this.style.left = '';
      this.style.right = '';
      this.classList.remove('tc-wa--arrastrando');
      this.ponerLado(r.left + r.width / 2 < window.innerWidth / 2 ? 'left' : 'right');
      this.fraccion = (window.innerHeight - r.bottom) / window.innerHeight;
      this.aplicarAbajo();
      guardar({ lado: this.lado, fraccion: this.abajo / window.innerHeight });
      this.esquivar();
    }

    alClic(e) {
      if (this.acabaDeArrastrar) {
        e.preventDefault();
        e.stopPropagation();
        this.acabaDeArrastrar = false;
        return;
      }
      var datos = { method: 'WhatsApp', pagina: this.dataset.pagina || '' };
      try { if (window.gtag) window.gtag('event', 'contact', datos); } catch (err) { /* sin GA */ }
      try { if (window.fbq) window.fbq('track', 'Contact', datos); } catch (err) { /* sin Meta */ }
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('tc_whatsapp_click', datos); } catch (err) { /* sin eventos */ }
    }
  }

  customElements.define('tc-whatsapp', TcWhatsapp);
})();
